<template>
  <div>
    <div class="" style="padding: 8px 12px">
      <el-button type="primary" size="small" @click="addHomework('')"
        v-if="flag !==true">添加作业</el-button
      >
    </div>
    <div class="work-list">
      <div v-for="item in listData" :key="item.value" class="work-box">
        <div class="work-main">
          <div class="work-title work-content">
            <p class="work-left">作业主题</p>
            <p>{{ item.topic | ellipsis }}</p>
          </div>
          <div class="work-content">
            <p class="work-left">状态</p>
            <p class="work-status">{{ item.status }}</p>
          </div>
          <div v-if="item.status === '已保存'">
            <div class="work-content">
              <p class="work-left">保存时间</p>
              <p>{{ item.updateDate | datetimeFormat }}</p>
            </div>
            <div class="work-content">
              <p class="work-left">预发布时间</p>
              <p>{{ item.startDate | datetimeFormat }}</p>
            </div>
          </div>
          <div v-else>
            <div class="work-content">
              <p class="work-left">发布时间</p>
              <p>{{ item.startDate | datetimeFormat }}</p>
            </div>
            <div class="work-content">
              <p class="work-left">截止时间</p>
              <p>{{ item.endDate | datetimeFormat }}</p>
            </div>
            <div class="work-content">
              <p class="work-left">提交人数</p>
              <p>{{ item.numerator }}/{{ item.denominator }}</p>
            </div>
          </div>
        </div>
        <div class="work-btn">
          <el-button
            type="primary"
            size="small"
            v-if="item.status == '已保存'"
            @click="issue(item.id)"
            >发布</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-if="item.status == '已保存'"
            @click="addHomework(item.id)"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="goList(item.id)"
            v-if="item.status == '已发布'"
            >批阅</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '@/utils/axios'
import * as api from '@/api/homework/homework'
import { confirmMsg } from '@/utils/common'
export default {
  name: 'HomeworkTeacher',
  //courseId 上一个页面点课程获取，courseType【1:点播;2:直播;】
  data() {
    return {
      // query:{
      //     courseId:"1",
      //     courseType:"1",
      //     createUserid:localStorage.getItem('uid') 
      // },
      // 分页
      pageObj: {
        page: '1',
        pageSize: '20',
      },
      listData: {},
      flag:true,
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 7) {
        return value.slice(0, 7) + '...'
      }
      return value
    },
  },
  props: ['courseId', 'courseType'],
  methods: {
    getCourseTeacherId() {
      console.log('---')
      api.getCourseTeacherId(this.getUId,this.courseId).then((res) => {
        if (res.data.code === 100000) {
          this.flag = res.data.data
        }
      })
    },
    //获取作业列表
    getlist() {
      //1.zy_video:点播课程;  2.zy_album:套餐课程 el_zy_order zy_order
      console.log(this.courseId)
      // this.createUserid=getUId();
      // const { courseId, courseType, createUserid }=this.query
      const { page, pageSize } = this.pageObj
      let reqdata = {
        courseId: this.courseId,
        courseType: this.courseType,
        page: page,
        pageSize: pageSize,
        createUserid: localStorage.getItem('uid') ,
      }
      api.getHomeworkList(reqdata).then((res) => {
        const result = res
        console.log(result.data.data.list)
        this.listData = result.data.data.list
        this.listData.forEach((item) => {
          //状态转换
          if (item.status === 0) {
            item.status = '已保存'
          } else if (item.status === 1) {
            item.status = '已发布'
          } else {
            item.status = '已审阅'
          }
          item.updateDate = formatUtcTime(item.updateDate)
          item.anticipatedDate = formatUtcTime(item.anticipatedDate)
        })
      })
    },
    // 跳转新增作业页面
    addHomework(id) {
      const url = 'HomeworkEdit'
      this.$router.push({
        name: url,
        edit_style: '0',
        query: {
          courseId: this.courseId,
          courseType: this.courseType,
          homeworkId: id,
        },
      })
    },
    //跳转作业列表页面
    goList(id) {
      const url = 'HomeworkList'
      this.$router.push({ name: url, query: { homeworkId: id } })
    },
    // 发布
    issue(id) {
      confirmMsg('是否发布该条数据？', async () => {
        console.log('---')
        let reqdata = {
          id: id,
          status: 1,
          courseId: this.courseId,
          createUserid: localStorage.getItem('uid') ,
        }
        api.saveZkolHomework(reqdata, '', '', '').then((res) => {
          if (res.data.code === 100000) {
            this.$message({ type: 'success', message: `发布成功！` })
            this.getlist()
          } else {
            this.$message({ type: 'warning', message: `发布失败！` })
          }
        })
      })
    },
  },
  mounted() {
    this.getCourseTeacherId()
    this.getlist()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
function formatUtcTime(v) {
  if (!v) {
    return ''
  }
  let date = new Date(v)
  date = new Date(date.valueOf())
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) +
    '-' +
    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
    ' ' +
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
    ':' +
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
    ':' +
    (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  )
}
</script>

<style lang="scss" scoped>
.work-list {
  padding: 10px;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}
.work-box {
  width: 280px;
  padding: 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3490196);
  margin-right: 20px;
  flex-shrink: 0;
  margin-top: 20px;
}
.work-main {
  height: 125px;
}
.work-title {
  font-size: 16px;
  font-weight: 600;
}
.work-content {
  font-size: 14px;
  margin-bottom: 6px;
}
.work-title > p,
.work-content > p {
  display: inline-block;
}
.work-left {
  width: 80px;
  text-align: right;
  margin-right: 20px;
}
.work-status {
  color: #0099ff;
}
.work-btn {
  margin-top: 10px;
  text-align: center;
}
</style>
